import reducer from './reducers';
import * as projectsSelectors from './selectors';
import * as projectsTypes from './types';

export { projectsSelectors, projectsTypes };

export default reducer;
